import React from 'react'
import { CategoryLandingIconBadge } from '../../../../components/categoryLanding/CategoryLandingSectionList'
import { buildLayoutConfig, COMMON_LAYOUT_EDITABLE_FIELDS, IntroStatsPanel, LayoutSections } from './layoutShared'

const DEFAULT_CONFIG = {
  heroBackgroundColor: '#f8f9fa',
  heroTextColor: '#1e293b',
  heroSubtitleColor: '#3b82f6',
  formBorderColor: '#3b82f6',
  formBorderWidth: 3,
  benefitsBackgroundColor: '#f1f5f9',
  benefitsTextColor: '#1e293b',
}

function CleanFormStyleLayout({
  mode = 'public',
  heroTitle,
  heroSubtitle,
  heroImageFileId,
  sections = [],
  formEnabled = true,
  introStats = [],
  customConfig = {},
  resolveAssetUrl,
  formCard = null,
  recommendedProductsCard = null,
  previewBanner = null,
  surveyModal = null,
  surveyDoneModal = null,
}) {
  const config = buildLayoutConfig('clean-form', customConfig, DEFAULT_CONFIG)
  const isLive = mode === 'live'
  const iconSections = (Array.isArray(sections) ? sections : []).filter((sec) => String(sec?.type || '').toLowerCase() === 'icon-grid')
  const bodySections = (Array.isArray(sections) ? sections : []).filter((sec) => String(sec?.type || '').toLowerCase() !== 'icon-grid')

  return (
    <div className="min-h-full bg-white text-slate-900 relative">
      {previewBanner}
      <div style={{ backgroundColor: config.heroBackgroundColor }} className="px-4 py-16 md:py-20 relative">
        <div className={`mx-auto ${isLive ? 'max-w-full space-y-4' : 'max-w-6xl'}`}>
          <div className={`grid grid-cols-1 ${isLive ? '' : 'lg:grid-cols-2'} gap-8 items-center`}>
            <div className="space-y-5">
              {heroTitle && <h1 className="whitespace-pre-line text-4xl md:text-5xl font-extrabold tracking-tight leading-tight" style={{ color: config.heroTextColor }}>{heroTitle}</h1>}
              {heroSubtitle && <p className="text-2xl md:text-3xl font-bold leading-9 whitespace-pre-line" style={{ color: config.heroSubtitleColor }}>{heroSubtitle}</p>}
              {heroImageFileId && (
                <div className="mt-8">
                  <img src={resolveAssetUrl(heroImageFileId)} alt="" className="max-w-full h-auto rounded-2xl" />
                </div>
              )}
            </div>

            {(formEnabled || recommendedProductsCard) && (
              <div className={isLive ? 'space-y-3' : 'lg:sticky lg:top-20 lg:self-start space-y-3'}>
                {formEnabled && formCard}
                {recommendedProductsCard}
              </div>
            )}
          </div>
        </div>
      </div>

      {iconSections.length > 0 && (
        <div style={{ backgroundColor: config.benefitsBackgroundColor }} className="px-4 py-14">
          <div className="mx-auto max-w-6xl">
            {iconSections.map((section, idx) => {
              const items = Array.isArray(section?.items) ? section.items : []
              const columns = section?.columns || 3
              const colsClass = columns === 2 ? 'md:grid-cols-2' : columns === 4 ? 'md:grid-cols-4' : 'md:grid-cols-3'
              return (
                <div key={idx} className={`grid grid-cols-1 ${colsClass} gap-8`}>
                  {items.map((it, itemIdx) => (
                    <div key={itemIdx} className="text-center">
                      <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-white shadow-sm">
                        <CategoryLandingIconBadge icon={it?.icon} title={it?.title} className="h-12 w-12 bg-slate-100 text-slate-700" />
                      </div>
                      <div className="mb-2 text-xl font-semibold leading-8" style={{ color: config.benefitsTextColor }}>{it?.title || ''}</div>
                      <div className="text-base leading-7 opacity-90" style={{ color: config.benefitsTextColor }}>{it?.description || ''}</div>
                    </div>
                  ))}
                </div>
              )
            })}
          </div>
        </div>
      )}

      <div className="px-4 py-14">
        <div className={`mx-auto ${isLive ? 'max-w-full space-y-4' : 'max-w-4xl space-y-6'}`}>
          <LayoutSections
            sections={bodySections}
            resolveAssetUrl={resolveAssetUrl}
            variant={isLive ? 'compact' : 'default'}
          />
          <IntroStatsPanel introStats={introStats} />
        </div>
      </div>

      {surveyModal}
      {surveyDoneModal}
    </div>
  )
}

export const cleanFormStyleLayout = {
  key: 'clean-form',
  label: '기본 템플릿 2 - 간편 문의형',
  description: '설명 영역과 상담 폼을 분리해 전환에 집중하는 레이아웃입니다.',
  editableConfigFields: [
    ...COMMON_LAYOUT_EDITABLE_FIELDS,
    { key: 'benefitsBackgroundColor', label: '혜택 섹션 배경색', placeholder: '#f1f5f9' },
    { key: 'benefitsTextColor', label: '혜택 섹션 글자색', placeholder: '#1e293b' },
  ],
  normalizeCustomConfig: (customConfig) => buildLayoutConfig('clean-form', customConfig, DEFAULT_CONFIG),
  Component: CleanFormStyleLayout,
}
